import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    userInfo: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : null,
    registerApps: [], // 有权限的子应用，用于注册微前端子应用(不包含未接入微前端的应用)
    userApps: [] // 已接入用户中心的并且有权限访问的应用(包含未接入微前端的应用)
  },
  getters: {
    isLogin({ userInfo }) {
      return Boolean(userInfo)
    },
    userName({ userInfo }) {
      return userInfo?.name
    }
  },
  mutations: {
    setUserInfo(state, payload) {
      localStorage.setItem('userInfo', JSON.stringify(payload))
      state.userInfo = payload
    },
    clearUserInfo(state) {
      localStorage.removeItem('userInfo')
      state.userInfo = null
    },
    setRegisterApps(state, payload) {
      state.registerApps = payload
    },
    setUserApps(state, payload) {
      state.userApps = payload
    }
  }
})
